import React from "react";
import "./Quotes.scss";
import flower from "../../assets/flower.svg";

function Quotes({ quotesContent }) {
  return (
    <section className="quote">
      <img
        className="flower quote__flower"
        src={flower}
        alt="Roberto Coin logo"
      ></img>
      <p
        className={`quote__copy ${
          quotesContent.class ? quotesContent.class : null
        }`}
      >
        {quotesContent.copy}
      </p>
    </section>
  );
}

export default Quotes;
